import { useCallback } from 'react';
import { useIntl } from 'react-intl';
import { Path, useNavigate } from 'react-router-dom';
import { DEFAULT_LANG } from '../../helpers/languageHelpers';

export const useNavigateWithLang = () => {
  const { locale } = useIntl();
  const navigate = useNavigate();

  const navigateWithLang = useCallback(
    (to: string | number | Partial<Path>, delay?: number) => {
      if (typeof to === 'number') {
        navigate(to as number);
        return;
      }
      if (typeof to !== 'string') {
        if (to?.pathname) {
          to.pathname = locale !== DEFAULT_LANG ? `/${locale}${to.pathname}` : to.pathname;
        }
        if (delay) {
          setTimeout(() => {
            navigate(to as Partial<Path>);
          }, delay);
        } else {
          navigate(to as Partial<Path>);
        }
        return;
      }

      let route: string = to as string;
      if (locale && locale !== DEFAULT_LANG) {
        route = `/${locale}${route}`;
      }
      navigate(route);
    },
    [navigate, locale]
  );

  return navigateWithLang;
};
